export default __webpack_public_path__ + "b7c3d802f4ac7b57dcb1f7caa54cc2ab.png";